import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import "./ReportsDash.css";
import moment from "moment";
import Calendar from "react-calendar";
import ReportDetails from "../../components/reportdetails/ReportDetails";
import { Context } from "../../context/Context";
import { useNavigate, useParams } from "react-router-dom";

const ReportsTab = () => {

  const { reportsData, setReportsData, contentReportsLoaded, setContentReportsLoaded, patientDate, setDate, dateInUse, setDateInUse } = useContext(Context);

  let dateToday = new Date();
  let dateYesterday = new Date(new Date().setDate(new Date().getDate() - 1));
  const [dateCompT] = useState(dateToday.toString().split(" ").splice(0, 4).join());
  const [dateCompY] = useState(dateYesterday.toString().split(" ").splice(0, 4).join());
  const [isOpenCalendar, setOpenCalendar] = useState(false);
  const searchBy = useRef("");
  const wrapperRef = useRef("");

  const isSuperAdmin =
    localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).super_admin === 1
        ? true
        : false
      : false;

  const setDateSearch = (param) => {
    setContentReportsLoaded(false);
    setDateInUse(param);
    if (param === "y") {
      let date = new Date().setDate(new Date().getDate() - 1);
      setDate(moment(date).format("l"));
    } else {
      setDate(moment(new Date()).format("l"));
    }
  };

  const setDateManually = (param) => {
    setContentReportsLoaded(false);
    if (param === "backwards") {
      let date = new Date(patientDate).setDate(new Date(patientDate).getDate() - 1);
      let dateComp = new Date(date).toString().split(" ").splice(0, 4).join();
      if (dateComp === dateCompT) {
        setDateInUse("t");
      } else if (dateComp === dateCompY) {
        setDateInUse("y");
      } else if (moment(dateComp) > moment(dateCompT)) {
        setDateInUse("future");
      } else if (moment(dateComp) < moment(dateCompT)) {
        setDateInUse("past");
      }
      setDate(moment(date).format("l"));
    } else if (param === "forward") {
      if (dateInUse === "t") {
        return false;
      }

      let date = new Date(patientDate).setDate(new Date(patientDate).getDate() + 1);
      let dateComp = new Date(date).toString().split(" ").splice(0, 4).join();
      if (dateComp === dateCompT) {
        setDateInUse("t");
      } else if (dateComp === dateCompY) {
        setDateInUse("y");
      } else if (moment(dateComp) > moment(dateCompT)) {
        setDateInUse("future");
      } else if (moment(dateComp) < moment(dateCompT)) {
        setDateInUse("past");
      }
      setDate(moment(date).format("l"));
    }
  };

  const openCalendar = (isOpen) => {
    setOpenCalendar(!isOpen);
  };

  function useOutsideCalenderAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpenCalendar(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideCalenderAlerter(wrapperRef);

  const updateDate = (newDate) => {
    setContentReportsLoaded(false);
    setDate(moment(newDate).format("l"));
    let dateComp = new Date(newDate).toString().split(" ").splice(0, 4).join();

    if (moment().isSameOrAfter(newDate) === false) {
      setDateInUse("future");
    } else {
      setDateInUse("past");
    }

    if (dateComp === dateCompT) {
      setDateInUse("t");
    } else if (dateComp === dateCompY) {
      setDateInUse("y");
    }
  };


  const [search, setSearch] = useState("");
  const updateSearchQuery = (value) => {
    setContentReportsLoaded(false);
    if (value && value.length >= 3) {
      setSearch(value);
    } else if (value === "") {
      setSearch("");
    }
  };

  useEffect(() => {
    getReports();
    // eslint-disable-next-line
  }, [patientDate, search]);

  const getReports = async () => {
    axios.defaults.headers.common["Authorization"] = await JSON.parse(localStorage.getItem("userData")).token;
    const patientDateStr = moment(patientDate, "MM/DD/YYYY").format("YYYY-MM-DD");
    await axios.post(window.ajaxLink + "cloud_programs/getPatientsReport", {
      patientDate: patientDateStr,
      search: search.trim(),
    })
      .then((res) => {
        if (res.data.responseData) {
          setReportsData(res.data.responseData);
          setContentReportsLoaded(true);
          setOpenCalendar(false);
        } else {
          setContentReportsLoaded(true);
          setOpenCalendar(false);
        }
      }).catch((err) => {
        console.error(err);
        setContentReportsLoaded(true);
        setOpenCalendar(false);
      });
  }


  return (
    <>
      {isSuperAdmin ? (
        <>
          <div className="dash_box_menu rpt_box_menu" style={{ marginBottom: '10px', gap: "10px" }}>
            <div className="dash_box_search_hold" style={{ maxWidth: "500px" }}>
              <input
                type="text"
                ref={searchBy}
                placeholder="Enter Patient name..."
                className="dash_box_search"
                onChange={() => updateSearchQuery(searchBy.current.value)}
              />
              <div className="dash_box_search_icon"></div>
            </div>
            {search === "" && (
              <div className="dash_box_filter_area">
                <div
                  className={"dash_box_filter_btn" + (dateInUse === "y" ? " btn_fill" : " btn_no_fill")}
                  onClick={() => setDateSearch("y")}
                >
                  Yesterday
                </div>
                <div
                  className={"dash_box_filter_btn dbf_no_marg " + (dateInUse === "t" ? " btn_fill" : " btn_no_fill")}
                  onClick={() => setDateSearch("t")}
                >
                  Today
                </div>
                <div className="dash_box_cali_filter">
                  {!isOpenCalendar ? (
                    <div className="cali_signifier" onClick={() => openCalendar(isOpenCalendar)}></div>
                  ) : (
                    <div className="cali_signifier_closed"></div>
                  )}
                  <div className="cali_date">{patientDate}</div>
                  <div className="cali_icon to_left" onClick={() => setDateManually("backwards")}></div>
                  <div
                    className={"cali_icon to_right " + (dateInUse === "t" ? "btn_disabled" : "")}
                    onClick={() => setDateManually("forward")}
                  ></div>
                </div>
                <div className="dash_box_filter_menu"></div>
              </div>
            )}
          </div>

          {isOpenCalendar && (
            <div ref={wrapperRef} className="calendar_contain report_calendar">
              <Calendar
                onChange={updateDate}
                value={new Date(patientDate)}
                formatShortWeekday={(locale, date) => ["S", "M", "T", "W", "T", "F", "S"][date.getDay()]}
                calendarType={"US"}
                maxDate={new Date()}
                view={"month"}
              />
            </div>
          )}

          <div className="table_scrollable_container_new" >
            <div className="table_scrollable_inner_container">

              {contentReportsLoaded ? (
                <>
                  {reportsData.length > 0 ? (
                    <>

                      <ReportDetails data={reportsData} patientDate={patientDate} />

                    </>
                  ) : (
                    <div className="no_content_notice_contain">
                      {search === "" ? (
                        <div className="programs_no_res_main">No reports available</div>
                      ) : (
                        <div className="programs_no_res_main">No patient found in reports</div>
                      )}
                    </div>
                  )}
                </>
              ) : (
                <div className="programs_table_no_content">
                  <div className="no_content_notice_contain">
                    <div className="p_load"></div>
                  </div>
                </div>
              )}

            </div>
          </div>
        </>
      ) : (
        <div className="no_content_notice_contain">
          <div className="programs_no_res_main">You have no permissions to see this info.</div>
        </div>
      )
      }
    </>
  );
};

export default ReportsTab;
